export default __webpack_public_path__ + "static/media/main-bar-group.98fe3ac3.png";